import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypePutSkusDisableParams } from '~/types/product.types';

/**
 * [상품관리][상품 등록/수정] 상품 삭제 API
 */
export const fetchPutSkusDisable = async (params: TypePutSkusDisableParams) => {
  const { data } = await axiosInstance.put<{ data: unknown }>(API_ENDPOINT.PRODUCT.DELETE_SKUS, params);
  return data.data;
};

/**
 * [상품관리][상품 등록/수정] 상품 삭제 Mutation Hook
 */
export const usePutSkusDisableMutation = () => {
  return useMutation({
    mutationFn: fetchPutSkusDisable,
  });
};
